var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "space-y-4" },
    [
      _vm._l(_vm.value, function (area, index) {
        return _c("ExteriorAreaForm", {
          key: area.id,
          attrs: { index: index, value: area },
          on: {
            input: (area) => _vm.updateArea(area, index),
            delete: (index) => _vm.deleteArea(index),
          },
        })
      }),
      _vm._v(" "),
      _c("AddButton", { on: { click: _vm.addArea } }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }